import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { Upload, Button } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8011';

const AddExpense = () => {
  const [title, setTitle] = useState('');
  const [amount, setAmount] = useState('');
  const [description, setDescription] = useState('');
  const [date, setDate] = useState('');
  const [category, setCategory] = useState('');
  const [categories, setCategories] = useState([]);
  const [project, setProject] = useState('');
  const [projects, setProjects] = useState([]);
  const [fileList, setFileList] = useState([]);
  // const [previewImage, setPreviewImage] = useState('');

  const navigate = useNavigate();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/categories/getAllCategories`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch categories');
        }

        const data = await response.json();
        if (Array.isArray(data)) {
          setCategories(data);
        } else {
          throw new Error('Categories data is not an array');
        }
      } catch (error) {
        console.error('Error fetching categories:', error);
        toast.error('Failed to load categories');
      }
    };

    // Set current date in yyyy-mm-dd format
    const currentDate = new Date().toISOString().split('T')[0];
    setDate(currentDate);

    fetchCategories();
  }, []);
  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/projects/getAllProjects`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch projects');
        }

        const data = await response.json();
        if (Array.isArray(data)) {
          setProjects(data);
        } else {
          throw new Error('Projects data is not an array');
        }
      } catch (error) {
        console.error('Error fetching projects:', error);
        toast.error('Failed to load projects');
      }
    };

    // Set current date in yyyy-mm-dd format
    const currentDate = new Date().toISOString().split('T')[0];
    setDate(currentDate);

    fetchProjects();
  }, []);

  const handleImageChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };

  const uploadImage = async (image) => {
    const data = new FormData();
    data.append('file', image);
    data.append('upload_preset', 'DecentBuilders');
    try {
      const response = await fetch('https://api.cloudinary.com/v1_1/dwbwxh3sj/image/upload', {
        method: 'POST',
        body: data,
      });
      const urlData = await response.json();
      return urlData.url;
    } catch (error) {
      toast.error('Image upload failed.');
      return null;
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem('token');
    if (!token) {
        toast.error('Please log in to add an expense.');
        navigate('/signIn');
        return;
    }

    // Upload multiple images to Cloudinary
    const imageUrls = await Promise.all(
        fileList.map(async (file) => {
            const uploadedUrl = await uploadImage(file.originFileObj);
            if (!uploadedUrl) {
                throw new Error('Failed to upload an image.');
            }
            return uploadedUrl;
        })
    );

    const expenseData = {
        title,
        price: Number(amount),
        description,
        date,
        category,
        project,
        imagePath: imageUrls, // Send array of image URLs
    };

    try {
        const response = await fetch(`${API_BASE_URL}/expenses/addExpense`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify(expenseData),
        });

        if (response.ok) {
            toast.success('Expense saved successfully!');
            // Reset form
            setTitle('');
            setAmount('');
            setDescription('');
            setDate(new Date().toISOString().split('T')[0]);
            setCategory('');
            setProject('');
            setFileList([]);
        } else {
            const errorText = await response.text();
            toast.error(`Failed to save expense: ${errorText}`);
        }
    } catch (error) {
        console.error('Error:', error);
        toast.error('An error occurred while saving expense.');
    }
};


  return (
    <div className="w-full mx-auto p-4 bg-white h-full">
      <h2 className="text-2xl font-semibold mb-6 text-themeColor2">Add Expense</h2>
      <form onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <div className="mb-4">
              <label className="block text-gray-700 mb-2">
                Title:
                <input
                  type="text"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  required
                  className="mt-1 block w-full px-3 py-2 border border-gray-300 bg-gray-100 rounded-md shadow-sm focus:outline-none focus:ring-themeColor focus:border-themeColor"
                />
              </label>
            </div>

            <div className="mb-4">
              <label className="block text-gray-700 mb-2">
                Amount:
                <input
                  type="number"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  required
                  className="mt-1 block w-full px-3 py-2 border border-gray-300 bg-gray-100 rounded-md shadow-sm focus:outline-none focus:ring-themeColor focus:border-themeColor"
                />
              </label>
            </div>

            <div className="mb-4">
            <label className="block text-gray-700 mb-2">
              Project:
              <select
                value={project}
                onChange={(e) => setProject(e.target.value)}
                required
                className="mt-1 block w-full px-3 py-2 border border-gray-300 bg-gray-100 rounded-md shadow-sm focus:outline-none focus:ring-themeColor focus:border-themeColor"
              >
              <option value="">Select Project</option>
              {projects.map((pro) => (
                <option key={pro._id} value={pro.project}>
                  {pro.project}
                </option>
              ))}
              </select>
            </label>
          </div>
          </div>

          <div>
            <div className="mb-4">
              <label className="block text-gray-700 mb-2">
                Category:
                <select
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                  required
                  className="mt-1 block w-full px-3 py-2 border border-gray-300 bg-gray-100 rounded-md shadow-sm focus:outline-none focus:ring-themeColor focus:border-themeColor"
                >
                  <option value="">Select Category</option>
                  {categories.map((cat) => (
                    <option key={cat._id} value={cat.category}>
                      {cat.category}
                    </option>
                  ))}
                </select>
              </label>
            </div>

            <div className="mb-4">
              <label className="block text-gray-700 mb-2">
                Date:
                <input
                  type="date"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                  required
                  className="mt-1 block w-full px-3 py-2 border border-gray-300 bg-gray-100 rounded-md shadow-sm focus:outline-none focus:ring-themeColor focus:border-themeColor"
                />
              </label>
            </div>

            <div className="mb-4">
              <label className="block text-gray-700 mb-2">
              Image (Optional):
              <Upload
              multiple
                listType="picture"
                fileList={fileList}
                onChange={handleImageChange}
                beforeUpload={() => false}
                className="mt-1 block w-full py-0 border border-gray-300 bg-gray-100 rounded-md shadow-sm focus:outline-none focus:ring-themeColor focus:border-themeColor"
              >
                <Button
                  icon={<UploadOutlined />}
                  className="mb-1 bg-transparent border-0 hover:!text-themeColor hover:!bg-transparent hover:text-themeColor2 focus:outline-none"
                >
                  Upload Image
                </Button>
              </Upload>
            </label>
          </div>
          </div>
        </div>

        <div className="mt-6 text-center">
          <div className="mb-4">
            <label className="block text-gray-700 mb-2 text-left">
              Description:
              <textarea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                required
                className="mt-1 block w-full px-3 py-2 border border-gray-300 bg-gray-100 rounded-md shadow-sm focus:outline-none focus:ring-themeColor focus:border-themeColor"
                rows="4"
              />
            </label>
          </div>
        </div>

        <div className="mt-20 text-center">
          <button
            type="submit"
            className="py-2 px-6 w-40 mt-10 bg-themeColor1 text-themeColor2 font-semibold rounded-md shadow-sm hover:bg-themeColor2 hover:text-themeColor1"
          >
            SAVE
          </button>
        </div>

        <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} newestOnTop={false} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      </form>
    </div>
  );
};

export default AddExpense;
